import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import SearchOffIcon from '@mui/icons-material/SearchOff';

interface WatchdogNoDataProps {
  message: string;
}

const WatchdogNoData: React.FC<WatchdogNoDataProps> = ({ message }) => {
  return (
    <Box 
      sx={{ 
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        padding: 3,
        paddingTop: 4
      }}
    >
      <Paper
        elevation={0}
        sx={{
          p: 4,
          border: '1px solid',
          borderColor: 'rgba(255, 207, 43, 0.3)', // FECF2B with opacity
          borderRadius: 2,
          background: (theme) => theme.palette.mode === 'dark' ? '#1d1d1b' : '#fff',
          textAlign: 'center',
          maxWidth: 600
        }}
      >
        <SearchOffIcon 
          sx={{ 
            fontSize: 64,
            color: '#FECF2B',
            mb: 2
          }} 
        />
        <Typography 
          variant="h5" 
          sx={{ 
            mb: 2,
            color: '#FECF2B',
            fontWeight: 500
          }}
        >
          No Data Available
        </Typography>
        <Typography 
          variant="body1"
          sx={{
            color: (theme) => theme.palette.mode === 'dark' ? '#fff' : '#666'
          }}
        >
          {message}
        </Typography>
      </Paper>
    </Box>
  );
};

export default WatchdogNoData; 